import * as React from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { Spinner, Icon, Intent } from '@blueprintjs/core';
import { translateKey } from 'app/utils/forms';

const AUDIO_COMPONENT_STYLE = {
    display: 'block',
    border: '1px solid #d9dadb',
    borderRadius: '3px',
    height: '38px',
    position: 'fixed',
    top: '20px',
    left: '20px',
    zIndex: '19',
    background: 'white'
}

interface Props {
    audioSource: string | string[];
    donePlaying: () => void;
};

interface State {
    audioLoading: boolean;
    audioPlaying: boolean;
    audioIndex: number;
}

export class CoachingAudio extends React.Component<Props, State> {

    state: State = {
        audioLoading: true,
        audioPlaying: false,
        audioIndex: 0
    }

    // @ts-ignore
    audioRef: React.RefObject<any> | any;

    getAudioElement = () => {
        if (this.audioRef === undefined) return undefined;
        return this.audioRef.audioEl;
    }

    readyToPlay = () => {
        // Wait 2 seconds so it's not so sudden
        setTimeout(() => {
            this.setState({
                audioLoading: false
            }, () => {
                this.handlePlay();
            });
        }, 2000);
    }

    handlePause = () => {
        const audio = this.getAudioElement();

        if (audio === undefined) return;

        audio.pause();

        this.setState({
            audioPlaying: false
        });
    }

    handlePlay = () => {
        const audio = this.getAudioElement();

        if (audio === undefined) return;

        audio.play();

        this.setState({
            audioPlaying: true
        });
    }

    handleReset = () => {
        const audio = this.getAudioElement();

        if (audio === undefined) return;

        try {
            audio.pause();
            audio.currentTime = 0;
            audio.play();

            this.setState({
                audioPlaying: true,
                audioIndex: 0
            });
        }
        catch (e) {

        }
    }

    isAudioPlaying = () => {
        const audio = this.getAudioElement();

        if (audio === undefined) return false;

        return !audio.paused;
    }

    renderControls = () => {
        const {
            audioLoading,
            audioPlaying
        } = this.state;

        if (audioLoading) {
            return <span style={{ display: 'inline-block', padding: '5px' }}>
                <Spinner size={26} />
            </span>
        }

        const pauseIcon = <Icon className={"audioControlIcon"} iconSize={26} icon="pause" onClick={this.handlePause} />
        const playIcon = <Icon className={"audioControlIcon"} iconSize={26} icon="play" onClick={this.handlePlay} />
        const resetIcon = <Icon className={"audioControlIcon"} iconSize={26} icon="reset" onClick={this.handleReset} />

        return <span>
            {audioPlaying ? pauseIcon : playIcon}
            {resetIcon}
        </span>
    }

    renderAudioPlayingIcon = () => {
        const {
            audioPlaying,
            audioLoading
        } = this.state;

        if (audioLoading === true) return undefined;
        if (audioPlaying === false) return undefined;

        return <span className="coachAudioIsPlaying">
            <Icon icon="volume-up" iconSize={26} intent={Intent.PRIMARY} />
        </span>
    }

    onLastIndex = () => {
        const {
            audioSource
        } = this.props;

        const {
            audioIndex
        } = this.state;

        if (Array.isArray(audioSource) === false) return true;

        return ((audioIndex + 1) >= audioSource.length);
    }

    getAudioSource = () => {
        const {
            audioSource
        } = this.props;

        const {
            audioIndex
        } = this.state;

        if (Array.isArray(audioSource) === false) return audioSource;

        return audioSource[audioIndex];
    }

    render() {
        const {
            audioIndex
        } = this.state;

        const choosenAudioSource = this.getAudioSource();

        // @ts-ignore
        return <span style={AUDIO_COMPONENT_STYLE}>
            <span className="coachAudioTitle">{translateKey('vleader.coach')}</span>
            {this.renderAudioPlayingIcon()}
            {this.renderControls()}
            <ReactAudioPlayer
                ref={(element) => { this.audioRef = element; }}
                style={{ display: 'none' }}
                src={choosenAudioSource}
                autoPlay={false}
                controls={false}
                onCanPlay={this.readyToPlay}
                onEnded={() => {
                    if (this.onLastIndex()) {
                        this.props.donePlaying();

                        this.setState({
                            audioPlaying: false
                        });
                    }
                    else {
                        this.setState({
                            audioIndex: audioIndex + 1
                        });
                    }
                }}
            />
        </span>
    }
}
